import React, { useEffect, useState } from 'react';
import styles from './procedimentos_dra_rebeccaalmeida.module.scss';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaChevronLeft, FaChevronRight, FaWhatsapp } from 'react-icons/fa';

const WHATSAPP_NUMBER = '5516992351900';

const procedimentos = [
    {
        titulo: 'Odontologia Estética e Clínica Geral',
        descricao: 'Prevenção e cuidados com a saúde bucal, incluindo limpeza, remoção de tártaro, tratamento de cáries (restaurações), tratamento de gengivite, tratamento para bruxismo, extrações simples, clareamento dental, reparos estéticos e atendimentos de urgência.',
        imagens: [require("./src/procedimento_1_1.png"), require("./src/procedimento_1_2.png"), require("./src/procedimento_1_3.png"), require("./src/procedimento_1_4.png"), require("./src/procedimento_1_5.png")] as string[],
        whatsappMessage: 'Olá! Gostaria de saber mais sobre Odontologia Estética e Clínica Geral e agendar uma avaliação.',
    },
    {
        titulo: 'Canal (Endodontia)',
        descricao: 'Tratamento indicado quando o dente está inflamado ou infeccionado. O procedimento remove a infecção interna do dente, alivia a dor e preserva o dente natural.',
        imagens: [require("./src/procedimento_2_1.png")] as string[],
        whatsappMessage: 'Olá! Gostaria de saber mais sobre tratamento de Canal (Endodontia) e agendar uma avaliação.',
    },
    {
        titulo: 'Prótese Dentária',
        descricao: 'Recuperação de dentes quebrados ou perdidos com próteses como pino e coroa, onlay, dentadura (prótese total ou parcial) e outras restaurações mais resistentes, devolvendo função, conforto e estética ao sorriso.',
        imagens: [require("./src/procedimento_3_1.png"), require("./src/procedimento_3_2.png"), require("./src/procedimento_3_3.png")] as string[],
        whatsappMessage: 'Olá! Gostaria de saber mais sobre Prótese Dentária e agendar uma avaliação.',
    },
    {
        titulo: 'Harmonização Orofacial',
        descricao: 'Procedimentos estéticos faciais como botox, preenchimento labial, harmonização facial completa (full face) e perfiloplastia, sempre com avaliação e planejamento personalizado.',
        imagens: [require("./src/procedimento_4_1.png"), require("./src/procedimento_4_2.png"), require("./src/procedimento_4_3.png"), require("./src/procedimento_4_4.png"), require("./src/procedimento_4_5.png"), require("./src/procedimento_4_6.png")] as string[],
        whatsappMessage: 'Olá! Gostaria de saber mais sobre Harmonização Orofacial e agendar uma avaliação.',
    },
];

interface CardProcedimentoProps {
    titulo: string;
    descricao: string;
    imagens: string[];
    whatsappMessage: string;
}

const CardProcedimento: React.FC<CardProcedimentoProps> = ({
    titulo,
    descricao,
    imagens,
    whatsappMessage,
}) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const hasImages = imagens.length > 0;
    const hasMultipleImages = imagens.length > 1;

    const prevImage = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (!hasMultipleImages) return;
        setCurrentIndex((prev) => (prev === 0 ? imagens.length - 1 : prev - 1));
    };

    const nextImage = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (!hasMultipleImages) return;
        setCurrentIndex((prev) => (prev === imagens.length - 1 ? 0 : prev + 1));
    };

    const handleWhatsAppClick = () => {
        window.open(
            `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(whatsappMessage)}`,
            '_blank'
        );
    };

    return (
        <div className={styles.card}>
            <div className={styles.carouselContainer}>
                {hasImages ? (
                    <>
                        <img src={imagens[currentIndex]} alt={titulo} />
                        {hasMultipleImages && (
                            <>
                                <button
                                    type="button"
                                    className={`${styles.carouselBtn} ${styles.prevBtn}`}
                                    onClick={prevImage}
                                    aria-label="Imagem anterior"
                                >
                                    <FaChevronLeft />
                                </button>
                                <button
                                    type="button"
                                    className={`${styles.carouselBtn} ${styles.nextBtn}`}
                                    onClick={nextImage}
                                    aria-label="Próxima imagem"
                                >
                                    <FaChevronRight />
                                </button>
                                <div className={styles.indicators}>
                                    {imagens.map((_, idx) => (
                                        <span
                                            key={idx}
                                            role="button"
                                            tabIndex={0}
                                            className={`${styles.dot} ${idx === currentIndex ? styles.active : ''}`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setCurrentIndex(idx);
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    setCurrentIndex(idx);
                                                }
                                            }}
                                            aria-label={`Ir para imagem ${idx + 1}`}
                                        />
                                    ))}
                                </div>
                            </>
                        )}
                    </>
                ) : (
                    <div className={styles.placeholderImagem}>
                        <span>Imagens em breve</span>
                    </div>
                )}
            </div>
            <h3>{titulo}</h3>
            {descricao ? <p className={styles.descricao}>{descricao}</p> : null}
            <button
                type="button"
                className={styles.whatsappBtn}
                onClick={handleWhatsAppClick}
            >
                <FaWhatsapp /> Falar no WhatsApp
            </button>
        </div>
    );
};

const Procedimentos_dra_rebeccaalmeida: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.procedimentos_dra_rebeccaalmeida}>
                <div className={styles.header}>
                    <Link to="/dra_rebeccaalmeida" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                    <h2>Procedimentos</h2>
                </div>
                <div className={styles.lista}>
                    {procedimentos.map((item, index) => (
                        <CardProcedimento
                            key={index}
                            titulo={item.titulo}
                            descricao={item.descricao}
                            imagens={item.imagens}
                            whatsappMessage={item.whatsappMessage}
                        />
                    ))}
                </div>
            </div>
            <div className={styles.footer}>
                <img
                    src={require('./src/logo.png')}
                    alt="Rebecca Almeida Odontologia e Estética"
                    className={styles.footerLogo}
                />
            </div>
        </div>
    );
};

export default Procedimentos_dra_rebeccaalmeida;
